// import React from "react";
// import { FaSearch, FaBell } from "react-icons/fa";

// export default function Header() {
// 	return (
// 		<header className="dashboard-header">
// 			<div className="container">
// 				<div className="header-content d-flex align-items-center justify-content-between">
// 					<div className="search-container">
// 						<FaSearch className="search-icon" size={14} />
// 						<input
// 							type="text"
// 							className="search-input form-control"
// 							placeholder="Search..."
// 							data-testid="input-search"
// 						/>
// 					</div>

// 					<div className="header-actions d-flex align-items-center">
// 						<button className="notification-btn btn" data-testid="button-notifications">
// 							<FaBell size={18} />
// 							<span className="notification-dot" data-testid="notification-dot"></span>
// 						</button>
// 						<div className="user-avatar" data-testid="img-avatar"></div>
// 					</div>
// 				</div>
// 			</div>
// 		</header>
// 	);
// }

import React from "react";
import { FaSearch, FaBell } from "react-icons/fa";

export default function Header() {
	return (
		<header className="dashboard-header">
			<div className="container">
				<div className="header-content">
					{/* Left: Logo/Title */}
					{/* <h2 className="header-title">Admin Dashboard</h2> */}

					{/* Middle: Search */}
					<div className="search-container">
						<FaSearch className="search-icon" />
						<input type="text" placeholder="Search..." className="search-input" />
					</div>

					{/* Right: Actions */}
					<div className="header-actions">
						<button className="notification-btn">
							<FaBell />
							<span className="notification-dot"></span>
						</button>
						<div className="user-avatar"></div>
					</div>
				</div>
			</div>
		</header>
	);
}
